<template>

<app-input :wide="wide" :messages="messages" v-on:toggle="onToggle" :locked="locked" :prefix="prefix" :toggle="toggle" :label="label" :stacked="stacked" :no-line="noLine" :notes="notes" :disabled="disabled" :validation="validation">

	<div class="text-wrapper" :class="{'has-prefix': textPrefix, 'has-suffix': textSuffix, 'has-max': maxlength, 'has-actions': hasCopy || hasOpen}">

		<div class="text-prefix" v-if="textPrefix">
			{{ textPrefix }}
		</div>

		<input ref="input" :class="{'is-locked': hasCopy || hasOpen}" v-on:keyup.enter="$emit('enter')" v-if="!autogrow" :type="(password) ? 'password' : 'text'" class="text" v-bind:value="value" :maxlength="maxlength" v-on:input="$emit('input', $event.target.value)" :placeholder="placeholder" />
		<textarea ref="input" v-if="autogrow" v-autogrow class="text" v-bind:value="value" v-on:input="$emit('input', $event.target.value)" :placeholder="placeholder" />

		<app-icon icon="loading" class="text-loading" v-if="loading" />

		<div class="text-max" v-tooltip="'Characters remaining'" v-if="maxlength" :class="{'is-warning': lengthWarning}">{{ lengthRemaining }}</div>

		<div class="text-suffix" v-if="textSuffix">
			{{ textSuffix }}
		</div>

		<app-icon icon="copy" v-if="hasCopy" v-tooltip="'Copy text'" class="text-action" v-on:click="onCopyClick" />
		<app-icon icon="open" v-if="hasOpen" v-tooltip="'Open link'" class="text-action" v-on:click="$emit('open')" />

	</div>

</app-input>

</template>

<script>

import copy from 'copy-to-clipboard'

export default {

	props: ['label', 'wide', 'messages', 'password', 'locked', 'loading', 'hasCopy', 'hasOpen', 'textSuffix', 'textPrefix', 'toggle', 'prefix', 'validation', 'numeric', 'autogrow', 'disabled', 'value', 'noLine', 'stacked', 'placeholder', 'notes', 'maxlength'],

	computed: {

		lengthRemaining: function() {

			return this.maxlength - this.value.length

		},

		lengthWarning: function() {

			return this.lengthRemaining < 10

		}

	},

	methods: {

		onToggle: function() {

			this.$emit('toggle')
			if (!this.toggle) this.$refs.input.focus()

		},

		onCopyClick: function() {
		
			copy(this.value)

			this.$notify({
				message: 'Successfully copied!'
			})

			this.$emit('copy')
		
		}

	}

}

</script>

<style scoped>

.text {
	line-height: 36px;
	font-size: 14px;
	width: 100%;
	padding: 0px 10px;
	color: #333;
	background-color: #fff;
	border-radius: 10px;
	border: 2px solid #eee;
}

.text.is-locked {
	pointer-events: none;
}

textarea.text {
	line-height: 20px;
	box-sizing: initial;
	width: calc(100% - 24px);
	padding: 10px;
	resize: none;
}

.text:focus {
	border-color: #4082d3;
}

.is-device .text {
	font-size: 14px;
}

.text-wrapper.has-actions,
.text-wrapper.has-prefix,
.text-wrapper.has-suffix {
	display: flex;
}

.text-suffix {
	line-height: 36px;
	font-size: 14px;
	padding: 0px 10px;
	color: #333;
	background-color: #eee;
	border-radius: 0px 12px 12px 0px;
	border: 2px solid #eee;
	flex-grow: 0;
	letter-spacing: 1px;
}

.text-prefix {
	line-height: 36px;
	font-size: 14px;
	padding: 0px 10px;
	color: #333;
	background-color: #eee;
	border-radius: 12px 0px 0px 12px;
	border: 2px solid #eee;
	flex-grow: 0;
	letter-spacing: 1px;
}

.text-wrapper.has-prefix .text {
	width: auto;
	flex-grow: 1;
	border-radius: 0px 12px 12px 0px;
}

.text-wrapper.has-actions .text,
.text-wrapper.has-suffix .text {
	width: auto;
	flex-grow: 1;
	border-radius: 12px 0px 0px 12px;
}

.text-loading {
	position: absolute;
	right: 10px;
	top: 12px;
	color: #4082d3;
	font-size: 16px;
}

.text-max {
	position: absolute;
	right: 10px;
	top: 0px;
	line-height: 40px;
	font-weight: 400;
	font-size: 12px;
	color: #ccc;
}

.text-wrapper.has-max >>> input {
	padding-right: 48px;
}

.text-max.is-warning {
	color: #c55b5b;
}

.text-action {
	background-color: #4082d3;
	width: 40px;
	height: 40px;
	cursor: pointer;
	color: #fff;
	line-height: 40px;
	text-align: center;
	font-size: 16px;
}

.is-desktop .text-action:hover {
	background-color: #236dc9;
}

.text-action:last-child {
	border-radius: 0px 12px 12px 0px;
}

</style>
